import { Select, CourseSet } from "../../types/requirement.response";
import CircularCheckmark from "../icons/CircularCheckmark";

interface RequirementTabBarProps {
    items: (Select | CourseSet)[];
    fulfilledIds: string[];
    activeTab: number;
    onTabChange: (index: number) => void;
}

export default function RequirementTabBar({
    items,
    fulfilledIds,
    activeTab,
    onTabChange,
}: RequirementTabBarProps) {
    const fulfilledSet = new Set(fulfilledIds);

    return (
        <div className="flex flex-wrap gap-1.5">
            {items.map((item, index) => {
                const isActive = index === activeTab;
                const isFulfilled = fulfilledSet.has(item.id);
                const atLeastUnitsCount = item.rule.atLeastUnitsCount;
                return (
                    <button
                        key={item.id}
                        onClick={() => onTabChange(index)}
                        className={`flex items-center gap-1 md:gap-1.5 px-2 py-1 md:px-3 md:py-1.5 rounded-full text-xs md:text-sm font-medium transition-colors whitespace-nowrap ${
                            isActive
                                ? "bg-indigo-100 text-indigo-700"
                                : "bg-gray-100 text-gray-500 hover:bg-gray-200 hover:text-gray-700"
                        }`}
                    >
                        <span>{item.title}</span>
                        {isFulfilled ? (
                            <CircularCheckmark className="h-3 w-3 md:h-4 md:w-4 text-green-500" />
                        ) : atLeastUnitsCount != null ? (
                            <span className={`text-xs ${isActive ? "text-indigo-400" : "text-gray-400"}`}>
                                {item.summary.completedUnitsCount}/{atLeastUnitsCount}
                            </span>
                        ) : null}
                    </button>
                );
            })}
        </div>
    );
}
